import FooterApp from './components/FooterApp.vue';
import UiButton from '../components/UiButton.vue';
import Vue from 'vue';

Vue.component('UiButton', UiButton);

export default new Vue({
	render: h => h(FooterApp)
});